// extracted by mini-css-extract-plugin
module.exports = {"loading":"TableLoading_loading__34CZD","content":"TableLoading_content__2zSxM","text":"TableLoading_text__3nEJu"};